import {
  Checkbox,
  CheckboxGroup,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Stack,
  Text,
} from "@chakra-ui/react";
import { Field } from "formik";

export const StatusAba = ({ children, props }) => {
  return (
    <>
      <Flex mb={4} justifyContent={"space-between"}>
        <Text
          fontWeight={700}
          fontSize="16px"
          lineHeight="21.6px"
          color={"#575553"}
        >
          Status{" "}
          <Text as="span" color="red">
            *
          </Text>
        </Text>
        {children}
      </Flex>

      <Field name="statusRelatorio">
        {({ field, form }) => (
          <FormControl
            isInvalid={
              form.errors.statusRelatorio && form.touched.statusRelatorio
            }
            id="statusRelatorio"
            width="max-content"
          >
            <FormLabel
              color="#5F6377"
              whiteSpace={"nowrap"}
              fontWeight="500"
              fontSize="14px"
              lineHeight="19.6px"
              htmlFor={"statusRelatorio"}
            >
              {"Selecione o Status"}
            </FormLabel>

            <CheckboxGroup
              value={field.value || []}
              onChange={(value) =>
                props.setFieldValue("statusRelatorio", value)
              }
            >
              <Stack flexDirection="row" alignItems={"end"} gap={4}>
                <Checkbox id="status-relatorio-ativo" value="A">
                  Ativo
                </Checkbox>

                <Checkbox id="status-relatorio-suspenso" value="S">
                  Suspenso
                </Checkbox>

                <Checkbox id="status-relatorio-desativado" value="D">
                  Desativado
                </Checkbox>
              </Stack>

              <FormErrorMessage mr="-14">
                {form.errors.statusRelatorio}
              </FormErrorMessage>
            </CheckboxGroup>
          </FormControl>
        )}
      </Field>
    </>
  );
};
